<admin-header [primaryButtons]="headerPrimaryButtons" [title]="title" (eventFired)="headerButtonClick($event)"></admin-header>
<div class="org-chart-container">
  <!-- Loading State -->
  <div class="loading-container" *ngIf="gridLoading">
    <div class="spinner"></div>
    <p>Loading organizational chart...</p>
  </div>

  <!-- Main Content -->
  <div *ngIf="!gridLoading">
    <!-- Header with controls -->
   <div class="org-chart-header">

      
      <div class="controls">


        <!-- Action buttons -->
        <div class="action-buttons">
          <button (click)="expandAll()" class="btn btn-secondary">
            Expand All
          </button>
          <button (click)="collapseAll()" class="btn btn-secondary">
            Collapse All
          </button>
       
        </div>
      </div>
    </div>

    <!-- Org chart tree -->
    <div class="org-chart-content">
      <div class="tree-container">
        <ng-container *ngFor="let root of filteredRoots">
          <div class="tree-root" style="padding-top:-20px">
            <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: root }">
            </ng-container>
          </div>
        </ng-container>
      </div>

     <!-- Selected user details panel -->
      <div class="details-panel" *ngIf="selectedNode">
        <div class="details-header">
          <h3>Employee Details</h3>
          <button (click)="selectedNode = null" class="close-btn">✕</button>
        </div>
        
        <div class="details-content">
          <div class="profile-section">
            <img 
              [src]="getProfileImage(selectedNode.user)" 
              [alt]="selectedNode.user.fullName"
              class="profile-image-large"
            />
            <h4>{{ selectedNode.user.fullName }}</h4>
            <p class="job-title">{{ selectedNode.user.jobTitle }}</p>
          </div>

          <div class="info-section">
            <div class="info-item">
              <span class="label">Employee ID:</span>
              <span class="value">{{ selectedNode.user.userId }}</span>
            </div>
			<div class="info-item" *ngIf="selectedNode.user.user.email">
              <span class="label">Email:</span>
              <span class="value">{{ selectedNode.user.user.email }}</span>
            </div>
            <div class="info-item" *ngIf="selectedNode.user.telephoneNumber">
              <span class="label">Phone:</span>
              <span class="value">{{ selectedNode.user.telephoneNumber }}</span>
            </div>
            <div class="info-item">
              <span class="label">Status:</span>
              <span class="value" [class.active]="selectedNode.user.isActive === true">
                {{ selectedNode.user.isActive === true ? 'Active' : 'Inactive' }}
              </span>
            </div>
            <div class="info-item">
              <span class="label">Direct Reports:</span>
              <span class="value">{{ selectedNode.children.length }}</span>
            </div>
            <div class="info-item">
              <span class="label">Total Team Size:</span>
              <span class="value">{{ getSubordinateCount() }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!-- Recursive node template -->
<ng-template #nodeTemplate let-node>
  <div class="tree-node">
    <div 
      class="node-card" 
      [class.selected]="selectedNode?.user?.userId === node.user.userId"
      [class.inactive]="node.user.IsActive !== '1'"
      (click)="selectNode(node)"
    >
      <div class="node-content">
        <img 
          [src]="getProfileImage(node.user)" 
          [alt]="node.user.FullName"
          class="profile-image"
        />
        <div class="node-info">
          <div class="node-name">{{ node.user.fullName }}</div>
          <div class="node-title">{{ node.user.jobTitle }}</div>
          <div class="node-stats" *ngIf="hasChildren(node)">
            <span class="report-count">
              {{ node.children.length }} direct {{node.children.length !== 1 ? "reports" : "report" }}
            </span>
          </div>
        </div>
        <button 
          *ngIf="hasChildren(node)"
          (click)="toggleNode(node.user.userId); $event.stopPropagation()"
          class="expand-btn"
          [class.expanded]="isExpanded(node.user.userId)"
        >
          <span *ngIf="isExpanded(node.user.userId)">▼</span>
          <span *ngIf="!isExpanded(node.user.userId)">▶</span>
        </button>
      </div>
    </div>

    <!-- Children -->
    <div class="node-children" *ngIf="hasChildren(node) && isExpanded(node.user.userId)">
      <div class="children-container">
        <ng-container *ngFor="let child of node.children">
          <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: child }">
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#grid' }" [(visible)]="gridLoading" [showIndicator]="true" [showPane]="true" [shading]="true"></dx-load-panel>